import { theme, colors, attributes } from './theme'
import { baseColors, baseUnit, iconSize, spacing, colorTokens } from './config'

export { baseColors, baseUnit, iconSize, spacing, colorTokens, colors, attributes }
export default theme
